import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SubscriptionWidget = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setIsSubscribed(true);
      setIsLoading(false);
      setEmail('');
    }, 1500);
  };

  if (isSubscribed) {
    return (
      <div className="card-elevated p-6 text-center">
        <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="CheckCircle" size={32} color="var(--color-success)" />
        </div>
        <h3 className="font-headline font-semibold text-lg text-text-primary mb-2">
          Successfully Subscribed!
        </h3>
        <p className="text-text-secondary mb-4">
          You'll receive exclusive market intelligence reports and breaking regulatory updates.
        </p>
        <Button
          variant="outline"
          onClick={() => setIsSubscribed(false)}
        >
          Subscribe Another Email
        </Button>
      </div>
    );
  }

  return (
    <div className="card-elevated p-6">
      <div className="flex items-center space-x-3 mb-4">
        <div className="w-12 h-12 gradient-accent rounded-lg flex items-center justify-center">
          <Icon name="Bell" size={24} color="white" />
        </div>
        <div>
          <h3 className="font-headline font-semibold text-lg text-text-primary">
            Market Intelligence Alerts
          </h3>
          <p className="text-sm text-text-secondary">
            Get exclusive insights delivered to your inbox
          </p>
        </div>
      </div>

      <form onSubmit={handleSubscribe} className="space-y-4">
        <Input
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full"
        />

        <Button
          type="submit"
          variant="default"
          fullWidth
          loading={isLoading}
          disabled={!email}
          className="bg-cta hover:bg-cta/90 text-cta-foreground"
          iconName="ArrowRight"
          iconPosition="right"
        >
          Subscribe to Alerts
        </Button>
      </form>

      <div className="mt-4 p-3 bg-muted/30 rounded-lg">
        <div className="flex items-start space-x-2">
          <Icon name="Shield" size={16} color="var(--color-success)" className="mt-0.5" />
          <div className="text-xs text-text-secondary">
            <p className="font-medium mb-1">What you'll receive:</p>
            <ul className="space-y-1">
              <li>• Weekly market trend analysis</li>
              <li>• Breaking regulatory updates</li>
              <li>• Exclusive industry reports</li>
              <li>• Talent market insights</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionWidget;